/* eslint-disable react/prop-types */ // TODO: add props
import { useEffect } from 'react';
import AppContainer from 'edrolo/domains/app/components/AppContainer';
import HtmlClassName from 'edrolo/domains/app/side-effects/HtmlClassName';
import LoadingIndicator from 'edrolo/domains/app/components/LoadingIndicator';
import { AnonymizerToggle } from 'edrolo/domains/anonymizer';
import { ExamGrid } from 'edrolo/domains/examGrids';
import { STATUS } from '../../constants';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import SelfReflectionQuestionSetResultsGrid from '../../components/SelfReflectionQuestionSetResultsGrid';
import { QuestionSetTopBar } from '../../components/QuestionSetTopBar';
import Waffle from 'edrolo/utils/Waffle';

// TODO: move this into the questionSetReview domain

const QuestionSetResultsGridPage = ({
  exam,
  flatQuestions,
  examStatus,
  examId,
  classId,
  loadExam,
  location,
  ExamGridComponent = ExamGrid, // allow injection for testing
  SelfReflectionQuestionSetResultsGridComponent = SelfReflectionQuestionSetResultsGrid,
  highlightProfileId,
}) => {
  useEffect(() => {
    if (examStatus !== STATUS.READY) {
      loadExam(examId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, [examId]);

  const isLoading = examStatus !== STATUS.READY;

  const allMultiChoice =
    !isLoading &&
    flatQuestions.every(
      (q) =>
        q.get('question_type') ===
        EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE
    );

  return (
    <AppContainer
      bodyClassName={
        allMultiChoice &&
        Waffle.flag_is_active('retain_old_maths_grid_experience_for_users')
          ? 'exam grid'
          : null
      }
      wide={!allMultiChoice}
      renderTopBar={() => (
        <QuestionSetTopBar isTeacher classId={classId} exam={exam} />
      )}
    >
      {allMultiChoice ? <HtmlClassName className="horizontal-scroll" /> : null}

      <AnonymizerToggle />
      {isLoading && <LoadingIndicator loadingText="Loading Question Set" />}

      {!isLoading &&
        (allMultiChoice &&
        Waffle.flag_is_active('retain_old_maths_grid_experience_for_users') ? (
          <ExamGridComponent
            classId={classId}
            examId={examId}
            highlightProfileId={highlightProfileId}
          />
        ) : (
          <SelfReflectionQuestionSetResultsGridComponent
            classId={classId}
            examId={examId}
            exam={exam}
            location={location}
            highlightProfileId={highlightProfileId}
          />
        ))}
    </AppContainer>
  );
};

export default QuestionSetResultsGridPage;
